// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Baloo&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Alatsi&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Crimson+Text&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*MOSTRAR ITEMS PEDIDO*/

  .barra-titulo-lista {

    width: 100%;
    height:auto;
    margin: 10px;
    padding: 10px;
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    flex-wrap: wrap;
    font-family: "Poppins", sans-serif;
    font-weight: 300;
    font-style: italic;
    color: rgba(95, 59, 59, 0.6);

}

.barra-titulo-lista h1 {

  text-align: left;
  margin-right:20px;
}

.barra-titulo-lista a {

 font-size: 20px;

}



  tr:nth-child(even) {
    background-color: whitesmoke;
  }

  .fondo-items-yellow {

  background-color: yellow;
  font-size: 12px;
  font-weight: bold;
  border-radius: 10px;
  text-align: center;
  align-items: center;
  height: 20px;

}

.fondo-items-blue {

  background-color: lightblue;
  font-size: 12px;
  font-weight: bold;
  border-radius: 10px;
  text-align: center;
  align-items: center;
  height: 20px;

}


.fondo-items-green {

  background-color: green;
  color: white;
  font-size: 12px;
  font-weight: bold;
  border-radius: 10px;
  text-align: center;
  align-items: center;
  height: 20px;

}

.fondo-items-purple {

  background-color: purple;
  color: white;
  font-size: 12px;
  font-weight: bold;
  border-radius: 10px;
  text-align: center;
  align-items: center;
  height: 20px;

}



  .tiempo {

    font-style: italic;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;  
    align-items: center;
    flex-wrap: wrap;
    text-align: center;

  }


  .status {

    display: flex;
    flex-direction: row;
    justify-content: space-evenly;  
    align-items: center;
    flex-wrap: wrap;

  }

  .detallesProductos {

    width: 100%;
    
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 1em;
     padding:  10px;
  }

  .productos {

  

    display: flex;
    flex-direction: column;
    justify-content: space-between;  
    align-items: center;
    flex-wrap: wrap;
    /* min-width: 230px; */
    flex-basis: 22%;
    min-height: 150px;
    border-radius: 10px;
    border: 0.5px dotted rgba(0,0,0,0.6);
    background-color: white;
    box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);
    transition: all 1s ease;
   
  
  }
  
  .acciones {
  
    width: 100%;
    display:flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }
 
  .productos .acciones {
  
   margin: 1px auto;
  
  }
  
  .producto {
  
    margin-top: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    width: 100%;
    overflow: hidden;
   
  
  }

    .cursorh4 {
  
      cursor: pointer;
    
     }
  
  
  /*MOSTRAR ITEMS PEDIDO*/

   /*INICIO*/

   .inicio {

    position: fixed;
    bottom: 5px;
    right: 5px;
    background-color: white;
    color: white;
    margin: 25px;
    width: 60px;
    height: 60px;
    border-radius: 50%;

   }

   .inicio img {

    width: 50%;
    height: 50%;
    object-fit: cover;

   }

   /*INICIO*/


.label-click {
  text-decoration: underline;
  cursor: pointer;
  color: #0056b3; /* opcional estilo link */
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.4);
  z-index: 10;
  display: flex;
  justify-content: center; /* Centra horizontal */
  align-items: center;     /* Centra vertical */
}

.popup {
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  min-width: 300px;
  box-shadow: 0 0 10px rgba(0,0,0,0.3);
}



.fecha_con {

  
  z-index: 10;
  width: 200px;
  height: 150px;
  left: 150px;
  margin-top: 2px;
  position: absolute;
  background-color: white;

  border-color: #333;
  border-style: dashed none dashed none ;
  border-width: 3px 2px 3px 4px;


}


ngb-alert {

  background-color: rgba(226, 214, 37, 0.8);
  height: 30px;
  border-radius: 10px;
  color: firebrick;
 
}

/*Tablas*/

th, td {

  font-size: 12px;
 
 }

 /*Tablas*/


.crimson {

  font-family: 'Crimson Text', serif;
  font-size: 20px;

}

.bg-blancohumo {

  background-color: whitesmoke;

}

.bg-blanco {

  background-color: whitesmoke;

}

.alto-tabla-cxp {

  min-height: 100px;
  max-height: 350px;
  overflow-y: auto;
  overflow-x: hidden;

}

.w-0 {

  width: 0%;

}


.imagen {
  width: 100%;
  height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.imagen img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/*Mensajes*/

.mensaje {
 position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  
  background: #fff9c4;            /* Fondo soft amarillo */
  color: #665c00;                 /* Texto elegante */
  border: 1px solid #ffe082;
  
  padding: 12px 25px;
  border-radius: 8px;

  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 15px;
  font-weight: 500;

  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  animation: fadeInOut 5s ease forwards;
}

/* Animación de entrada y salida */
@keyframes fadeInOut {
  0%   { opacity: 0; transform: translate(-50%, 20px); }
  10%  { opacity: 1; transform: translate(-50%, 0); }
  90%  { opacity: 1; transform: translate(-50%, 0); }
  100% { opacity: 0; transform: translate(-50%, 20px); }
}

/* Variante éxito */
.mensaje.success {
  background: #c8e6c9;
  border-color: #a5d6a7;
  color: #1b5e20;
}

/* Variante error */
.mensaje.error {
  background: #ffcdd2;
  border-color: #ef9a9a;
  color: #b71c1c;
}

/*Mensajes*/


.contenedor-titulo {
  height: 100%;
}


.fuente-alatsi {

  font-family: 'Alatsi', Courier, monospace;
  font-size: 15px;

}

.fuente-baloo {

  font-family: 'Baloo', Courier, monospace;
  font-size: 20px;

}

h1 {

   font-family: 'Alatsi';
  color: rgb(243, 156, 18);
  font-style: normal;
  font-weight: lighter;
  font-size: 30px;

}

a {

   font-family: 'Baloo', cursive;
  color: orange;
  align-content: center;
  align-items: center;
  font-size: 30px;
  
}

.contenedor {

  display: flex;
  flex-direction: row;
  align-items: center;  
  justify-content: space-between;
  margin-right: 100px;
 

}


.contenedor-modal {

  display: flex;
  align-items: center;
  justify-content: space-between;
 
}




.img-foto {
  margin-top: 10px;
  border-radius: 50%;
  width: 150px;
  height: 150px;
  box-shadow: 0 0px 0px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.contenedor-basicos {
  
  z-index: 10;
  position: fixed;
  display: flex;
  /* align-content: center; */
  align-items: center;
  top: 0px;
  right: 0px;
  height: 100%;
  width: 50%;
  background-color: white;
  margin:0px;
  padding: 0px;
  border-left: 1px dashed;

}


.spinner {
  
  z-index: 20;
  /* align-content: center; */
  position: fixed;
  top: 0px;
  height: 100vh;
  width: 100%;
  margin:0px;
  overflow: hidden;
  background-color: white; /*rbga(74,74,74,1);*/
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

}


.no-scrollcte {


  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  
  width: 80%;
  left: 20%;
  margin-left: 10px;
  margin-top: 1px;
  overflow-y: none;
  overflow-x: auto;
  height: 200px;
  background-color: whitesmoke;
  z-index: 1;
  position: absolute;
  border-radius: 10px;
}

 .cerrar {

  position: absolute;
  top: 30px;
  right: 10px;

  background-color: #333;
  color: #fff;
  cursor: pointer;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  z-index: 2;
  transition: all 1s linear;
 
}

.cerrar:hover {

  background-color: #fff ;
  color: #333;

}

.no-scrollresumen {

  display: inline-block;
  width: 100%;
  margin-top: 1px;
  overflow-y: auto;
  overflow-x: hidden;
  height: 400px;
  
}


.no-scrollart {

  display: inline-block;
  width: 100%;
  margin-top: 1px;
  overflow-y: none;
  overflow-x: auto;
  max-height: auto;
}

.ditto {

  cursor: pointer;

}

/*Articulos*/

.rc-contenedor {

  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
 
 }

.rc-contenedor-div {

  width: 600px;
  padding: 5px;
  right: auto;
  border-bottom: #333 1px dashed;
}

  .rc-contenedor-div h1 {

    color: orange;
    font-size: 20px;
    font-family: 'Baloo', Courier, monospace;
    text-align: center;
  }

  .rc-contenedor-div h4 {

    color:gray;
    font-size: 17px;
    font-family: 'Alatsi', Courier, monospace;
    text-align: center;
  }

  .rc-contenedor-div h4 a {

    color:gray;
    font-size: 16px;
    font-family: 'Alatsi', Courier, monospace;
    text-align: center;
  }


  .rc-contenedor-div .row input {

  
    border-radius: 0px;
    height: 34px;
  }
  

.articulos {

  display: inline-flex;
   flex-direction: column;
  /* justify-content: center;   */
  /* align-items: center;  */
  min-width: 230px;
  height: 185px;
  margin-left: 5px;
  margin-top: 7px;
  margin-bottom: 10px;
  border-radius: 10px;
  box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);

  font-family: 'Baloo', Courier, monospace;

  position: relative;

  transition: all 1s ease;
  border: 1px dashed rgba(0, 0, 0, 0.2);
 
}


 .articulo {

  
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding-top: 5px;
  

}

.articulo h3 {

  font-family: 'Baloo', Courier, monospace;
  font-size: 20px;

}

.articulo p {

  font-family: 'Baloo', Courier, monospace;
  font-size: 15px;

}


.caracteristicas {

  margin-top: 5px;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-evenly;
  
} 


.footer {

  /* position: fixed; */

  bottom: 0px;
  position: relative;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  align-items:center;
  justify-content: baseline;
  text-align: center;
  
}


.no-scrollcom {

  background-color: #fafbfd;
  display: inline-block;
  width: 100%;
  margin-top: 1px;
  overflow-y: none;
  overflow-x: auto;
  height: 140px;
  
}


.componentes {

  display: inline-flex;
   flex-direction: column;
  /* justify-content: center;   */
  /* align-items: center;  */
  min-width: 230px;
  height: 130px;
  margin-left: 5px;
  margin-top: 7px;
  margin-bottom: 5px;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);

  font-family: 'Baloo', Courier, monospace;
  font-size: 13px;
  position: relative;

  transition: all 1s ease;
 
}


 .componente {
 
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding-top: 1px;

}

.componente h3 {

  padding-top: 1px;

  font-family: 'Baloo', Courier, monospace;
  font-size: 15px;

}

.componente p {

  padding-top: 1px;

  font-family: 'Baloo', Courier, monospace;
  font-size: 13px;

}


.componente .caracteristicas {

  margin-top: 1px;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-evenly;
  
} 


.componente .footer {

  /* position: fixed; */

  bottom: 0px;
  position: relative;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  align-items:center;
  justify-content: baseline;
  text-align: center;
  
}




button  {

  border-radius: 40px;
  padding-left:  8px;
  padding-right: 8px;
}


.footer a {

  /*
  height: 100%;
  display: block;
  text-align: center;
  */
  position: absolute;
  bottom: 0px;
  
  width: 100%;
  cursor: pointer;
  background-color: white;
  color: black;
  border-radius: 0 0 10px 10px;
  transition: all 1s ease;
  font-size: 20px;

} 

.footer  a:hover {

  color: white;
  background-color: black;

}


.caracteristicas span {

  margin-left: 1%;
  width: 25%;

}


.caracteristicas input {

  width: 65%;
  border: none;
  border-radius: 10px;
  text-align: right;

}


/* Proveedores y clientes */

.detalleClientes {

 
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1em;
}

.clientes {

  display: flex;
  flex-direction: column;
  justify-content: center;  
  align-items: center;
  flex-wrap: wrap;
  flex-basis: 20%;
  height: auto;
  background-color: white;
  /* filter: brightness(1.2); */
  border-radius: 10px;
  border: 1px dashed rgba(0, 0, 0, 0.19);
  box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);

  transition: all 1s ease;


}

.cliente {

  margin-top: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  gap: 0.5em;
  overflow: hidden;

}

.acciones {

  width: 100%;
  display:inline-flex;
  justify-content: center;
  justify-items: center;

}

.clientes .acciones {

  margin: 1px auto;

}


.agregar {

  bottom: 0;
  width: 100%;
  text-align: center;
  position: relative;
 
  

}


.agregar  a {

  left: 0px;
  bottom: 0;
  position: absolute;
  width: 100%;
  font-size: 15px;
  font-weight: 600;
 
  color: black;
  background-color: white;
 
 
  border-radius: 0 0 10px 10px;
  height: auto;
  cursor: pointer;
  transition: all 1s ease;

}

.agregar a:hover {

  color: white;
  background-color: black;
  

}

 .cliente h4 {

  font-size: 11px;
  /*  font-family: 'Baloo', cursive; */
  color: black;

}

h4 {

  font-family: "Poppins", sans-serif;
  font-weight: 300;
  font-style: normal;
  font-size: 24px;
  
  color: orange;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  justify-items: center;
  gap: 0.2em;

}

.cliente p {

  font-size: 12px;
  /*  font-family: 'Baloo', cursive; */
  font-weight: 600;
  color: black;
  text-align: center;
}

.detalleItem {

  z-index: 5;
  position: fixed;
  top: 0px;
  right:0px;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  background-color: rgba(51, 58, 70, 0.8);

}

.nuevo {

  z-index: 2;
  position: fixed;
  top: 0px;
  right:0px;
  height: 100%;
  width: 100%;
  background-color: white;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,0.8);

}

.detalleItem .contenedor{

  position: absolute;
  top:80px;
  bottom:120px;
  right: 0px;
  width: 60%;
  height: 80%;
  overflow-y: hidden;
}

/* .proveedores {

  z-index: 5;
  position: absolute;
  margin-top: 25px;
  right: 0px;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  cursor: pointer;
} */

.mensaje {

  z-index: 5;
  position: absolute;
  right: 0px;
  width: 90%;
  bottom: 0px;
  overflow-y: auto;
  cursor: pointer;
}

.input-label {

  background-color: transparent;
  overflow: hidden;
  border: none;
  width: 500px;
  color: black;
}


h1 span {

  font-size: 15px;
  color: #333;

}

h1 span::before {

  content: "(( ";
  color: orange;

}

h1 span::after {

  content: " ))";
  color: orange;

}


.color-azul {

  color: blue;
  font-size: 13px;

}

.color-rojo {

  color: red;
  font-size: 13px;
}

.alto-tabla {

  min-height: 100px;
  max-height: 350px;
  overflow-y: auto;
  overflow-x: hidden;

}


.detalleItem .contenedor .items {

  background-color: white;
  width: 100%;
  height:auto;
  overflow: auto;

}

.nuevo .contenedor-modal{


  position: absolute;
  background-color:white;
  top:0px;
  right: 0px;
  width: 80%;
  height: 100%;

}

.items {
  padding-top:10px;
  padding-bottom: 40px;
  background-color: white;
  width: 100%;
  height: 100%;
  overflow: auto;

}

.division {

  position: relative;
  margin-bottom: 2px;
  width: 100%;
  height: 35px;
  background-color: whitesmoke;
}

.division .boton {

  position: absolute;
  left: 0px;
  height: 100%;

}

.efecto-filtro {

  filter: blur(0px);


}

.movimiento {

  transition: all 0.5s ease;

}

.filtro {

  filter: blur(8px);

}

.clientes:hover {

  transform: scale(1.05);

}

.mostrar-cursor {

  cursor: pointer;

}

.modal-entidad {

  position: fixed;
  z-index: 3;
  top: 35px;
  right:0px;
  height: 380px;
  width: 500px;
  background-color: white;
  border-bottom: dashed 1px ;
}

.lista-alto {

  height: 200px;
  width: 100%;
  overflow-y: auto;

}

.modal-entidad-items {

  position: absolute;
  margin-top: 2px;
  width: 100%;
  height: 100%;


}

.row input {

  border-radius: 10px;

}

.rows {

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 7px;
  

}


.rows .buscar {

 
  width: 0;
  opacity: 0;
  pointer-events: none;
  transition: all 1s ease;

}

hr {

  margin-top: 1px;
  margin-left: 5px;
  left: 0px;
  background-color: orange;
  height: 2px;
  width: 45%;


}

.rows .buscar-mostrar {

  border-radius: 40px;
  width: 45%;
  height: 40px;
  margin-right: 5px;
  margin-left: 10px;
  opacity: 1;
  background-color: lightgray;
  transition: all 0.5s ease;
}

.rows .buscar-mostrar:focus {

  background-color: transparent;

}

.rows span {

  transition: all 0.5s ease;

}

/* Clientes */
.no-scrollusr {

  margin: 0;
  padding: 0;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  height: 65vh;


}

.no-scrollusr a {

   margin: 10px 10px;
   font-size: 15px;
   color: orange;

}

.no-scrollusr a:hover {

  cursor: pointer;
  color: blue;

}

#modal-basic-title {

  margin-left: 10px;
  font-family: 'Ballo', Verdana, Geneva, Tahoma, sans-serif;
  font-size: 30px;
  font-weight: 600;
  color: orange;

}

.alto-tabla {

  display: inline-block;
  width: 100%;
  margin-top: 1px;
  margin-left: 5px;
  margin-right: 5px;
  
  max-height: 250px;
  overflow-y: auto;
  overflow-x: hidden;

}

.centrar {

  text-align: center;
  margin-top: 30px;

}


/**/

.empresas {

  display: inline-block;
  width: 100%;
  height: auto;
  right: auto;
  left: auto;
  
  overflow: hidden;
  }
  
  .empresas .items {
  
    display: inline-block;
    width: 300px;
    margin-right: 15px;
    max-height: 300px;
    margin-bottom: 15px;
    overflow: hidden;
    color: #333;
    box-shadow: 5px 5px 5px 0px rgba(51, 51, 51, 0.20);
    -webkit-box-shadow: 5px 5px 5px 0px rgba(51, 51, 51, 0.20);
    -moz-box-shadow: 5px 5px 5px 0px rgba(51, 51, 51, 0.20);
    border-radius: 5px;

  }
  
  .empresas .items img {
  
    width: 150px;
    height: 150px;
  
  }
  
  .empresas .items .empresa {
  
    width: 100%;
    height: 100%;
   display: flex;
   flex-direction: column;

  }

  .empresas .items .empresa p {

    margin: 1px;
    font-size: 15px;

  }

  .empresas .acciones {

    width: 100%;
    height: auto;
    display:flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    
  }
  
/**/

.contenedor-listado {

  margin-left: 0;
  margin-top: 20px;
  padding: 0px;
  width: 100%;
  height: 300px;
  display: flex;
  overflow-y: auto;
  overflow-x: hidden;
  
}


.listado {

  width: 100%;
  justify-content: center;
  align-items: center;

}


.listado-art {

  z-index: 5;
  position: absolute;
  width: 97%;
  max-height: 200px;
  cursor: pointer;


}

.listado-art ul {

  height: 200px;
  overflow-y: scroll;
}

.tablas-block {

  display: inline-block;
  width: 90%;
  height: auto;
  text-align: left;
  margin-left: auto;
  margin-top: 7px;
  margin-bottom: 8px;
  margin-right: auto;
  background-color: white;
  box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);


}

.tablas-block .agregar {

 margin: 5px auto;

}

.items-tabla {

  margin: 3px;
  width: 100%;
  background-color: white;

  overflow: hidden;

}

.identificador {

  width: 49%;
  font-family: 'Baloo', cursive;
  padding-right: 5px;
  text-align: right;
 
}

.detalle {

  width: 49%;
  color: #333;
  text-align: left;
  padding-right: 5px;
  font-family: 'Alatsi', cursive;


  }


@media screen and (max-width:820px) {

  .contenedor-basicos {

    width: 100%;

  }

 .clientes {

   flex-basis: 30%;

  } 

  .empresas .items {
  
    display: inline-block;
    padding:  5px;
    width: 100%;
    height: auto;
  }

}

/* Formateamos el label que servirá de contenedor */
.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
}

/* Ocultamos el checkbox html */
.switch input {
  display:none;
}

/* Formateamos la caja del interruptor sobre la cual se deslizará la perilla de control o slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

/* Pintamos la perilla de control o slider usando el selector before */
.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: .4s;
}

/* Cambiamos el color de fondo cuando el checkbox esta activado */
input:checked + .slider {
  background-color: #E27AD8;
}

/* Deslizamos el slider a la derecha cuando el checkbox esta activado */
input:checked + .slider:before {
  transform: translateX(13px);
}

/* Aplicamos efecto de bordes redondeados en slider y en el fondo del slider */
.slider.round {
  border-radius: 17px;
}

.slider.round:before {
  border-radius: 50%;
}

.centrar-label {

  display: flex;
  align-items: center;
}

.w-15 {

  width: 15%;

}

.proveedores {

  z-index: 5;
  position: absolute;
  width: 95%;
  cursor: pointer;
  max-height: 300px;
  overflow: auto;

}

.proveedores .ulx {

  position: relative;
  height: 100%;

}

.paginas {

  margin-left: 5px;
  width: 100%;
  height: auto;
  overflow-x:auto;
 

}

.paginas::-webkit-scrollbar {

  width: 0.5rem;
  height: 0.5rem;

}

.paginas::-webkit-scrollbar-thumb {

 border-radius: .5rem;
 background-color: #0004;
 visibility: hidden;

}

.paginas:hover::-webkit-scrollbar-thumb {

  visibility: visible;

}


.proveedores .ulx li {


  background-color: #333;
  color: white;
  border-bottom-color: white;
  font-family: 'Alatsi', Courier, monospace;

}

/* LOCALIDADES */
.presentacion {

  margin: 0px;
  width: 100%;

  max-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;



}

.presentacion .detalles {

margin: 0px;
width: 100%;
height: 100%;
padding-bottom: 1px;
display: flex;
flex-direction: row;
align-items: center;
justify-content: center;



}

.presentacion .detalles .items {

margin: 5px;
width: 30%;
height: 600px ;
padding: 0px;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
padding-top: 3px;
overflow: hidden;
cursor: pointer;

border-bottom: 0.3px solid lightgray;



}

.presentacion .detalles .items:hover {

background-color:  white;
box-shadow: 0px 0px 10px 1px  rgba(190, 169, 169, 0.75);

}



.presentacion .detalles .items .fondo-logo {

margin-top: 50px;
margin: 1px;
width: 100%;
height:30%;

display: flex;
flex-direction: column;
align-items: center;
overflow: hidden;

}

.presentacion .detalles .items .logo {

margin-top: 50px;
margin: 1px;
width: 40%;

height:auto;

}

.presentacion .detalles .items  .logo img {


background: transparent;

width: 100%;
height: auto;
border-radius: 50%;


}

.presentacion .detalles .items .subtitulo {

padding-top: 1px;
margin: 1px;
width: 100%;

height:auto;
background-size: cover;
text-align: center;

}

.presentacion .detalles .items .subtitulo h1 {

width: 100%;
margin-top: 2px;
font-size: 150%;

color: #e26a2c;
text-align: center;

}

.presentacion .detalles .items  .resumen {

padding-top: 1px;
margin: 1px;
width: 100%;
height: 90%;
overflow: hidden;
background-size: cover;
text-align: center;
padding-bottom: 0px;
margin-bottom: 0px;



}

.presentacion .detalles .items .resumen h2 {

width: 100%;
padding: 10px;
color: #3d3d3e;
text-align: justify;
font-size: 18px;
font-size: 110%;


}

.naranja1 {

background-color: #ffd792;
background-color: white;

}
.naranja2 {

background-color: #ffae6a;
background-color: whitesmoke;

}

/*@GOOGLE*/
.material-symbols-outlined {
  cursor: pointer;
  font-variation-settings:
  'FILL' 0,
  'wght' 400,
  'GRAD' 0,
  'opsz' 24
}

.btn-google {

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.md-24 {

  font-size: 24px;

}

.md-25 {

  font-size: 24px;

}

.md-36 {

  font-size: 36px;

}

.md-48 {

  font-size: 48px;

}

/*@GOOGLE*/

@media screen and (max-width:920px) { 

 /*LOCALIDADES*/

 .presentacion .detalles {

  width: 100%;
  height:auto;
  flex-direction: column;

}

.presentacion .detalles .items {

  width: 100%;
  height: 100%;
  /* -webkit-box-shadow: 0px 2px 2px 0px rgba(190, 169, 169, 0.75);
  -moz-box-shadow: 0px 2px 2px 0px  rgba(190, 169, 169, 0.75);
  box-shadow: 0px 2px 2px 0px  rgba(190, 169, 169, 0.75); */


}

.presentacion .detalles .items .logo {


  width: 25%;
  height: auto;

}


}


@media screen and (max-width:720px) {

  .contenedor-basicos {

    width: 100%;

  }

  .nuevo .contenedor {

    width: 100%;

  }

  /* .clientes {

    width: 100%;
    min-width: 120px;

  } */

 

}
`, "",{"version":3,"sources":["webpack://./src/app/app.component.css"],"names":[],"mappings":"AAOE,uBAAuB;;EAEvB;;IAEE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;;AAEhC;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;CAEC,eAAe;;AAEhB;;;;EAIE;IACE,4BAA4B;EAC9B;;EAEA;;EAEA,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;;AAEd;;AAEA;;EAEE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;;AAEd;;;AAGA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;;AAEd;;AAEA;;EAEE,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;;AAEd;;;;EAIE;;IAEE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,kBAAkB;;EAEpB;;;EAGA;;IAEE,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;;EAEjB;;EAEA;;IAEE,WAAW;;IAEX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,QAAQ;KACP,cAAc;EACjB;;EAEA;;;;IAIE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,oCAAoC;IACpC,uBAAuB;IAGvB,sDAAsD;IACtD,uBAAuB;;;EAGzB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;;GAEC,gBAAgB;;EAEjB;;EAEA;;IAEE,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;;;EAGlB;;IAEE;;MAEE,eAAe;;KAEhB;;;EAGH,uBAAuB;;GAEtB,SAAS;;GAET;;IAEC,eAAe;IACf,WAAW;IACX,UAAU;IACV,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;;GAEnB;;GAEA;;IAEC,UAAU;IACV,WAAW;IACX,iBAAiB;;GAElB;;GAEA,SAAS;;;AAGZ;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc,EAAE,yBAAyB;AAC3C;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,uBAAuB,EAAE,sBAAsB;EAC/C,mBAAmB,MAAM,oBAAoB;AAC/C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;AACtC;;;;AAIA;;;EAGE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,uBAAuB;;EAEvB,kBAAkB;EAClB,sCAAsC;EACtC,6BAA6B;;;AAG/B;;;AAGA;;EAEE,yCAAyC;EACzC,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;;AAElB;;AAEA,SAAS;;AAET;;EAEE,eAAe;;CAEhB;;CAEA,SAAS;;;AAGV;;EAEE,kCAAkC;EAClC,eAAe;;AAEjB;;AAEA;;EAEE,4BAA4B;;AAE9B;;AAEA;;EAEE,4BAA4B;;AAE9B;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;;AAEpB;;AAEA;;EAEE,SAAS;;AAEX;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA,WAAW;;AAEX;CACC,eAAe;EACd,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;;EAEb,mBAAmB,aAAa,wBAAwB;EACxD,cAAc,kBAAkB,mBAAmB;EACnD,yBAAyB;;EAEzB,kBAAkB;EAClB,kBAAkB;;EAElB,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;;EAEhB,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA,kCAAkC;AAClC;EACE,OAAO,UAAU,EAAE,gCAAgC,EAAE;EACrD,OAAO,UAAU,EAAE,6BAA6B,EAAE;EAClD,OAAO,UAAU,EAAE,6BAA6B,EAAE;EAClD,OAAO,UAAU,EAAE,gCAAgC,EAAE;AACvD;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,WAAW;;;AAGX;EACE,YAAY;AACd;;;AAGA;;EAEE,yCAAyC;EACzC,eAAe;;AAEjB;;AAEA;;EAEE,wCAAwC;EACxC,eAAe;;AAEjB;;AAEA;;GAEG,qBAAqB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;;AAEjB;;AAEA;;GAEG,6BAA6B;EAC9B,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;;AAEjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;;;AAGrB;;;AAGA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;AAEhC;;;;;AAKA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,4EAA4E;AAC9E;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,uBAAuB;;AAEzB;;;AAGA;;EAEE,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,QAAQ;EACR,aAAa;EACb,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,uBAAuB,EAAE,oBAAoB;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;;AAExB;;;AAGA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;;EAEf,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;CAEC;;EAEC,kBAAkB;EAClB,SAAS;EACT,WAAW;;EAEX,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,yBAAyB;;AAE3B;;AAEA;;EAEE,uBAAuB;EACvB,WAAW;;AAEb;;AAEA;;EAEE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;;AAEf;;;AAGA;;EAEE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA,YAAY;;AAEZ;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;;CAElB;;AAED;;EAEE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,8BAA8B;AAChC;;EAEE;;IAEE,aAAa;IACb,eAAe;IACf,wCAAwC;IACxC,kBAAkB;EACpB;;EAEA;;IAEE,UAAU;IACV,eAAe;IACf,yCAAyC;IACzC,kBAAkB;EACpB;;EAEA;;IAEE,UAAU;IACV,eAAe;IACf,yCAAyC;IACzC,kBAAkB;EACpB;;;EAGA;;;IAGE,kBAAkB;IAClB,YAAY;EACd;;;AAGF;;EAEE,oBAAoB;GACnB,sBAAsB;EACvB,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EAGnB,sDAAsD;;EAEtD,wCAAwC;;EAExC,kBAAkB;;EAElB,uBAAuB;EACvB,qCAAqC;;AAEvC;;;CAGC;;;EAGC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;;;AAGlB;;AAEA;;EAEE,wCAAwC;EACxC,eAAe;;AAEjB;;AAEA;;EAEE,wCAAwC;EACxC,eAAe;;AAEjB;;;AAGA;;EAEE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,6BAA6B;;AAE/B;;;AAGA;;EAEE,qBAAqB;;EAErB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;;AAEpB;;;AAGA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;;AAEf;;;AAGA;;EAEE,oBAAoB;GACnB,sBAAsB;EACvB,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EAGtB,sDAAsD;;EAEtD,wCAAwC;EACxC,eAAe;EACf,kBAAkB;;EAElB,uBAAuB;;AAEzB;;;CAGC;;EAEC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;;AAElB;;AAEA;;EAEE,gBAAgB;;EAEhB,wCAAwC;EACxC,eAAe;;AAEjB;;AAEA;;EAEE,gBAAgB;;EAEhB,wCAAwC;EACxC,eAAe;;AAEjB;;;AAGA;;EAEE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,6BAA6B;;AAE/B;;;AAGA;;EAEE,qBAAqB;;EAErB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;;AAEpB;;;;;AAKA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA;;EAEE;;;;GAIC;EACD,kBAAkB;EAClB,WAAW;;EAEX,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,uBAAuB;EACvB,eAAe;;AAEjB;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;;AAEzB;;;AAGA;;EAEE,eAAe;EACf,UAAU;;AAEZ;;;AAGA;;EAEE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;;AAEnB;;;AAGA,2BAA2B;;AAE3B;;;EAGE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,sCAAsC;EAGtC,sDAAsD;;EAEtD,uBAAuB;;;AAGzB;;AAEA;;EAEE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,UAAU;EACV,gBAAgB;;AAElB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;;AAEvB;;AAEA;;EAEE,gBAAgB;;AAElB;;;AAGA;;EAEE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kBAAkB;;;;AAIpB;;;AAGA;;EAEE,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;;EAEhB,YAAY;EACZ,uBAAuB;;;EAGvB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,uBAAuB;;AAEzB;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;;;AAGzB;;CAEC;;EAEC,eAAe;EACf,oCAAoC;EACpC,YAAY;;AAEd;;AAEA;;EAEE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;;EAEf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,UAAU;;AAEZ;;AAEA;;EAEE,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,eAAe;EACf,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;;AAEzC;;AAEA;;EAEE,UAAU;EACV,eAAe;EACf,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;;AAEnC;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;;;;;;;;GAUG;;AAEH;;EAEE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;;AAGA;;EAEE,eAAe;EACf,WAAW;;AAEb;;AAEA;;EAEE,cAAc;EACd,aAAa;;AAEf;;AAEA;;EAEE,cAAc;EACd,aAAa;;AAEf;;;AAGA;;EAEE,WAAW;EACX,eAAe;;AAEjB;;AAEA;;EAEE,UAAU;EACV,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;;AAEpB;;;AAGA;;EAEE,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,cAAc;;AAEhB;;AAEA;;;EAGE,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,UAAU;EACV,UAAU;EACV,YAAY;;AAEd;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;;AAEhB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,YAAY;;AAEd;;AAEA;;EAEE,iBAAiB;;;AAGnB;;AAEA;;EAEE,yBAAyB;;AAE3B;;AAEA;;EAEE,iBAAiB;;AAEnB;;AAEA;;EAEE,sBAAsB;;AAExB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA;;EAEE,eAAe;EACf,UAAU;EACV,SAAS;EACT,SAAS;EACT,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,gBAAgB;;AAElB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;;;AAGd;;AAEA;;EAEE,mBAAmB;;AAErB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;;;AAGpB;;;AAGA;;;EAGE,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,uBAAuB;;AAEzB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,wBAAwB;EACxB,WAAW;EACX,UAAU;;;AAGZ;;AAEA;;EAEE,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;;AAE/B;;AAEA;;EAEE,yBAAyB;;AAE3B;;AAEA,aAAa;AACb;;EAEE,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;;;AAGd;;AAEA;;GAEG,iBAAiB;GACjB,eAAe;GACf,aAAa;;AAEhB;;AAEA;;EAEE,eAAe;EACf,WAAW;;AAEb;;AAEA;;EAEE,iBAAiB;EACjB,yDAAyD;EACzD,eAAe;EACf,gBAAgB;EAChB,aAAa;;AAEf;;AAEA;;EAEE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;;EAEjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;;AAEpB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;;AAElB;;;AAGA,GAAG;;AAEH;;EAEE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,UAAU;;EAEV,gBAAgB;EAChB;;EAEA;;IAEE,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,kDAAkD;IAClD,0DAA0D;IAC1D,uDAAuD;IACvD,kBAAkB;;EAEpB;;EAEA;;IAEE,YAAY;IACZ,aAAa;;EAEf;;EAEA;;IAEE,WAAW;IACX,YAAY;GACb,aAAa;GACb,sBAAsB;;EAEvB;;EAEA;;IAEE,WAAW;IACX,eAAe;;EAEjB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;;EAErB;;AAEF,GAAG;;AAEH;;EAEE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,kBAAkB;;AAEpB;;;AAGA;;EAEE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;;AAErB;;;AAGA;;EAEE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,eAAe;;;AAGjB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EAIvB,sDAAsD;;;AAGxD;;AAEA;;CAEC,gBAAgB;;AAEjB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,uBAAuB;;EAEvB,gBAAgB;;AAElB;;AAEA;;EAEE,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;;AAEnB;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;;;EAG9B;;;AAGF;;EAEE;;IAEE,WAAW;;EAEb;;CAED;;GAEE,eAAe;;EAEhB;;EAEA;;IAEE,qBAAqB;IACrB,aAAa;IACb,WAAW;IACX,YAAY;EACd;;AAEF;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,YAAY;AACd;;AAEA,kGAAkG;AAClG;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,eAAe;AACjB;;AAEA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,eAAe;AACjB;;AAEA,iEAAiE;AACjE;EACE,yBAAyB;AAC3B;;AAEA,uEAAuE;AACvE;EAGE,2BAA2B;AAC7B;;AAEA,8EAA8E;AAC9E;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;;AAEZ;;AAEA;;EAEE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,cAAc;;AAEhB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;;AAEd;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;;;AAGjB;;AAEA;;EAEE,aAAa;EACb,cAAc;;AAEhB;;AAEA;;CAEC,oBAAoB;CACpB,uBAAuB;CACvB,kBAAkB;;AAEnB;;AAEA;;EAEE,mBAAmB;;AAErB;;;AAGA;;;EAGE,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;EAC1B,yCAAyC;;AAE3C;;AAEA,gBAAgB;AAChB;;EAEE,WAAW;EACX,WAAW;;EAEX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;;;;AAIzB;;AAEA;;AAEA,WAAW;AACX,WAAW;AACX,YAAY;AACZ,mBAAmB;AACnB,aAAa;AACb,mBAAmB;AACnB,mBAAmB;AACnB,uBAAuB;;;;AAIvB;;AAEA;;AAEA,WAAW;AACX,UAAU;AACV,cAAc;AACd,YAAY;AACZ,aAAa;AACb,sBAAsB;AACtB,uBAAuB;AACvB,mBAAmB;AACnB,gBAAgB;AAChB,gBAAgB;AAChB,eAAe;;AAEf,oCAAoC;;;;AAIpC;;AAEA;;AAEA,wBAAwB;AAGxB,uDAAuD;;AAEvD;;;;AAIA;;AAEA,gBAAgB;AAChB,WAAW;AACX,WAAW;AACX,UAAU;;AAEV,aAAa;AACb,sBAAsB;AACtB,mBAAmB;AACnB,gBAAgB;;AAEhB;;AAEA;;AAEA,gBAAgB;AAChB,WAAW;AACX,UAAU;;AAEV,WAAW;;AAEX;;AAEA;;;AAGA,uBAAuB;;AAEvB,WAAW;AACX,YAAY;AACZ,kBAAkB;;;AAGlB;;AAEA;;AAEA,gBAAgB;AAChB,WAAW;AACX,WAAW;;AAEX,WAAW;AACX,sBAAsB;AACtB,kBAAkB;;AAElB;;AAEA;;AAEA,WAAW;AACX,eAAe;AACf,eAAe;;AAEf,cAAc;AACd,kBAAkB;;AAElB;;AAEA;;AAEA,gBAAgB;AAChB,WAAW;AACX,WAAW;AACX,WAAW;AACX,gBAAgB;AAChB,sBAAsB;AACtB,kBAAkB;AAClB,mBAAmB;AACnB,kBAAkB;;;;AAIlB;;AAEA;;AAEA,WAAW;AACX,aAAa;AACb,cAAc;AACd,mBAAmB;AACnB,eAAe;AACf,eAAe;;;AAGf;;AAEA;;AAEA,yBAAyB;AACzB,uBAAuB;;AAEvB;AACA;;AAEA,yBAAyB;AACzB,4BAA4B;;AAE5B;;AAEA,UAAU;AACV;EACE,eAAe;EACf;;;;;AAKF;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA;;EAEE,eAAe;;AAEjB;;AAEA,UAAU;;AAEV;;CAEC,cAAc;;CAEd;;EAEC,WAAW;EACX,WAAW;EACX,sBAAsB;;AAExB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ;;2DAEyD;;;AAG3D;;AAEA;;;EAGE,UAAU;EACV,YAAY;;AAEd;;;AAGA;;;AAGA;;EAEE;;IAEE,WAAW;;EAEb;;EAEA;;IAEE,WAAW;;EAEb;;EAEA;;;;;KAKG;;;;AAIL","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Baloo&display=swap');\r\n@import url('https://fonts.googleapis.com/css?family=Alatsi&display=swap');\r\n@import url('https://fonts.googleapis.com/css2?family=Crimson+Text&display=swap');\r\n@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\r\n\r\n\r\n\r\n  /*MOSTRAR ITEMS PEDIDO*/\r\n\r\n  .barra-titulo-lista {\r\n\r\n    width: 100%;\r\n    height:auto;\r\n    margin: 10px;\r\n    padding: 10px;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: left;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    font-family: \"Poppins\", sans-serif;\r\n    font-weight: 300;\r\n    font-style: italic;\r\n    color: rgba(95, 59, 59, 0.6);\r\n\r\n}\r\n\r\n.barra-titulo-lista h1 {\r\n\r\n  text-align: left;\r\n  margin-right:20px;\r\n}\r\n\r\n.barra-titulo-lista a {\r\n\r\n font-size: 20px;\r\n\r\n}\r\n\r\n\r\n\r\n  tr:nth-child(even) {\r\n    background-color: whitesmoke;\r\n  }\r\n\r\n  .fondo-items-yellow {\r\n\r\n  background-color: yellow;\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  border-radius: 10px;\r\n  text-align: center;\r\n  align-items: center;\r\n  height: 20px;\r\n\r\n}\r\n\r\n.fondo-items-blue {\r\n\r\n  background-color: lightblue;\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  border-radius: 10px;\r\n  text-align: center;\r\n  align-items: center;\r\n  height: 20px;\r\n\r\n}\r\n\r\n\r\n.fondo-items-green {\r\n\r\n  background-color: green;\r\n  color: white;\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  border-radius: 10px;\r\n  text-align: center;\r\n  align-items: center;\r\n  height: 20px;\r\n\r\n}\r\n\r\n.fondo-items-purple {\r\n\r\n  background-color: purple;\r\n  color: white;\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  border-radius: 10px;\r\n  text-align: center;\r\n  align-items: center;\r\n  height: 20px;\r\n\r\n}\r\n\r\n\r\n\r\n  .tiempo {\r\n\r\n    font-style: italic;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-evenly;  \r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    text-align: center;\r\n\r\n  }\r\n\r\n\r\n  .status {\r\n\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-evenly;  \r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n\r\n  }\r\n\r\n  .detallesProductos {\r\n\r\n    width: 100%;\r\n    \r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    gap: 1em;\r\n     padding:  10px;\r\n  }\r\n\r\n  .productos {\r\n\r\n  \r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;  \r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    /* min-width: 230px; */\r\n    flex-basis: 22%;\r\n    min-height: 150px;\r\n    border-radius: 10px;\r\n    border: 0.5px dotted rgba(0,0,0,0.6);\r\n    background-color: white;\r\n    -webkit-box-shadow: 5px 5px 5px 0px rgba(190, 169, 169, 0.75);\r\n    -moz-box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);\r\n    box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);\r\n    transition: all 1s ease;\r\n   \r\n  \r\n  }\r\n  \r\n  .acciones {\r\n  \r\n    width: 100%;\r\n    display:flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n  }\r\n \r\n  .productos .acciones {\r\n  \r\n   margin: 1px auto;\r\n  \r\n  }\r\n  \r\n  .producto {\r\n  \r\n    margin-top: 5px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    text-align: center;\r\n    width: 100%;\r\n    overflow: hidden;\r\n   \r\n  \r\n  }\r\n\r\n    .cursorh4 {\r\n  \r\n      cursor: pointer;\r\n    \r\n     }\r\n  \r\n  \r\n  /*MOSTRAR ITEMS PEDIDO*/\r\n\r\n   /*INICIO*/\r\n\r\n   .inicio {\r\n\r\n    position: fixed;\r\n    bottom: 5px;\r\n    right: 5px;\r\n    background-color: white;\r\n    color: white;\r\n    margin: 25px;\r\n    width: 60px;\r\n    height: 60px;\r\n    border-radius: 50%;\r\n\r\n   }\r\n\r\n   .inicio img {\r\n\r\n    width: 50%;\r\n    height: 50%;\r\n    object-fit: cover;\r\n\r\n   }\r\n\r\n   /*INICIO*/\r\n\r\n\r\n.label-click {\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n  color: #0056b3; /* opcional estilo link */\r\n}\r\n\r\n.overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0,0,0,0.4);\r\n  z-index: 10;\r\n  display: flex;\r\n  justify-content: center; /* Centra horizontal */\r\n  align-items: center;     /* Centra vertical */\r\n}\r\n\r\n.popup {\r\n  background: #fff;\r\n  padding: 20px;\r\n  border-radius: 6px;\r\n  min-width: 300px;\r\n  box-shadow: 0 0 10px rgba(0,0,0,0.3);\r\n}\r\n\r\n\r\n\r\n.fecha_con {\r\n\r\n  \r\n  z-index: 10;\r\n  width: 200px;\r\n  height: 150px;\r\n  left: 150px;\r\n  margin-top: 2px;\r\n  position: absolute;\r\n  background-color: white;\r\n\r\n  border-color: #333;\r\n  border-style: dashed none dashed none ;\r\n  border-width: 3px 2px 3px 4px;\r\n\r\n\r\n}\r\n\r\n\r\nngb-alert {\r\n\r\n  background-color: rgba(226, 214, 37, 0.8);\r\n  height: 30px;\r\n  border-radius: 10px;\r\n  color: firebrick;\r\n \r\n}\r\n\r\n/*Tablas*/\r\n\r\nth, td {\r\n\r\n  font-size: 12px;\r\n \r\n }\r\n\r\n /*Tablas*/\r\n\r\n\r\n.crimson {\r\n\r\n  font-family: 'Crimson Text', serif;\r\n  font-size: 20px;\r\n\r\n}\r\n\r\n.bg-blancohumo {\r\n\r\n  background-color: whitesmoke;\r\n\r\n}\r\n\r\n.bg-blanco {\r\n\r\n  background-color: whitesmoke;\r\n\r\n}\r\n\r\n.alto-tabla-cxp {\r\n\r\n  min-height: 100px;\r\n  max-height: 350px;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n\r\n}\r\n\r\n.w-0 {\r\n\r\n  width: 0%;\r\n\r\n}\r\n\r\n\r\n.imagen {\r\n  width: 100%;\r\n  height: 90vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.imagen img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: contain;\r\n  display: block;\r\n}\r\n\r\n/*Mensajes*/\r\n\r\n.mensaje {\r\n position: fixed;\r\n  bottom: 30px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  z-index: 9999;\r\n  \r\n  background: #fff9c4;            /* Fondo soft amarillo */\r\n  color: #665c00;                 /* Texto elegante */\r\n  border: 1px solid #ffe082;\r\n  \r\n  padding: 12px 25px;\r\n  border-radius: 8px;\r\n\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\r\n  animation: fadeInOut 5s ease forwards;\r\n}\r\n\r\n/* Animación de entrada y salida */\r\n@keyframes fadeInOut {\r\n  0%   { opacity: 0; transform: translate(-50%, 20px); }\r\n  10%  { opacity: 1; transform: translate(-50%, 0); }\r\n  90%  { opacity: 1; transform: translate(-50%, 0); }\r\n  100% { opacity: 0; transform: translate(-50%, 20px); }\r\n}\r\n\r\n/* Variante éxito */\r\n.mensaje.success {\r\n  background: #c8e6c9;\r\n  border-color: #a5d6a7;\r\n  color: #1b5e20;\r\n}\r\n\r\n/* Variante error */\r\n.mensaje.error {\r\n  background: #ffcdd2;\r\n  border-color: #ef9a9a;\r\n  color: #b71c1c;\r\n}\r\n\r\n/*Mensajes*/\r\n\r\n\r\n.contenedor-titulo {\r\n  height: 100%;\r\n}\r\n\r\n\r\n.fuente-alatsi {\r\n\r\n  font-family: 'Alatsi', Courier, monospace;\r\n  font-size: 15px;\r\n\r\n}\r\n\r\n.fuente-baloo {\r\n\r\n  font-family: 'Baloo', Courier, monospace;\r\n  font-size: 20px;\r\n\r\n}\r\n\r\nh1 {\r\n\r\n   font-family: 'Alatsi';\r\n  color: rgb(243, 156, 18);\r\n  font-style: normal;\r\n  font-weight: lighter;\r\n  font-size: 30px;\r\n\r\n}\r\n\r\na {\r\n\r\n   font-family: 'Baloo', cursive;\r\n  color: orange;\r\n  align-content: center;\r\n  align-items: center;\r\n  font-size: 30px;\r\n  \r\n}\r\n\r\n.contenedor {\r\n\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;  \r\n  justify-content: space-between;\r\n  margin-right: 100px;\r\n \r\n\r\n}\r\n\r\n\r\n.contenedor-modal {\r\n\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n \r\n}\r\n\r\n\r\n\r\n\r\n.img-foto {\r\n  margin-top: 10px;\r\n  border-radius: 50%;\r\n  width: 150px;\r\n  height: 150px;\r\n  box-shadow: 0 0px 0px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\r\n}\r\n\r\n.contenedor-basicos {\r\n  \r\n  z-index: 10;\r\n  position: fixed;\r\n  display: flex;\r\n  /* align-content: center; */\r\n  align-items: center;\r\n  top: 0px;\r\n  right: 0px;\r\n  height: 100%;\r\n  width: 50%;\r\n  background-color: white;\r\n  margin:0px;\r\n  padding: 0px;\r\n  border-left: 1px dashed;\r\n\r\n}\r\n\r\n\r\n.spinner {\r\n  \r\n  z-index: 20;\r\n  /* align-content: center; */\r\n  position: fixed;\r\n  top: 0px;\r\n  height: 100vh;\r\n  width: 100%;\r\n  margin:0px;\r\n  overflow: hidden;\r\n  background-color: white; /*rbga(74,74,74,1);*/\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n\r\n}\r\n\r\n\r\n.no-scrollcte {\r\n\r\n\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  \r\n  width: 80%;\r\n  left: 20%;\r\n  margin-left: 10px;\r\n  margin-top: 1px;\r\n  overflow-y: none;\r\n  overflow-x: auto;\r\n  height: 200px;\r\n  background-color: whitesmoke;\r\n  z-index: 1;\r\n  position: absolute;\r\n  border-radius: 10px;\r\n}\r\n\r\n .cerrar {\r\n\r\n  position: absolute;\r\n  top: 30px;\r\n  right: 10px;\r\n\r\n  background-color: #333;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  height: 35px;\r\n  width: 35px;\r\n  border-radius: 50%;\r\n  z-index: 2;\r\n  transition: all 1s linear;\r\n \r\n}\r\n\r\n.cerrar:hover {\r\n\r\n  background-color: #fff ;\r\n  color: #333;\r\n\r\n}\r\n\r\n.no-scrollresumen {\r\n\r\n  display: inline-block;\r\n  width: 100%;\r\n  margin-top: 1px;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  height: 400px;\r\n  \r\n}\r\n\r\n\r\n.no-scrollart {\r\n\r\n  display: inline-block;\r\n  width: 100%;\r\n  margin-top: 1px;\r\n  overflow-y: none;\r\n  overflow-x: auto;\r\n  max-height: auto;\r\n}\r\n\r\n.ditto {\r\n\r\n  cursor: pointer;\r\n\r\n}\r\n\r\n/*Articulos*/\r\n\r\n.rc-contenedor {\r\n\r\n  width: 100%;\r\n  height: auto;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-top: 100px;\r\n \r\n }\r\n\r\n.rc-contenedor-div {\r\n\r\n  width: 600px;\r\n  padding: 5px;\r\n  right: auto;\r\n  border-bottom: #333 1px dashed;\r\n}\r\n\r\n  .rc-contenedor-div h1 {\r\n\r\n    color: orange;\r\n    font-size: 20px;\r\n    font-family: 'Baloo', Courier, monospace;\r\n    text-align: center;\r\n  }\r\n\r\n  .rc-contenedor-div h4 {\r\n\r\n    color:gray;\r\n    font-size: 17px;\r\n    font-family: 'Alatsi', Courier, monospace;\r\n    text-align: center;\r\n  }\r\n\r\n  .rc-contenedor-div h4 a {\r\n\r\n    color:gray;\r\n    font-size: 16px;\r\n    font-family: 'Alatsi', Courier, monospace;\r\n    text-align: center;\r\n  }\r\n\r\n\r\n  .rc-contenedor-div .row input {\r\n\r\n  \r\n    border-radius: 0px;\r\n    height: 34px;\r\n  }\r\n  \r\n\r\n.articulos {\r\n\r\n  display: inline-flex;\r\n   flex-direction: column;\r\n  /* justify-content: center;   */\r\n  /* align-items: center;  */\r\n  min-width: 230px;\r\n  height: 185px;\r\n  margin-left: 5px;\r\n  margin-top: 7px;\r\n  margin-bottom: 10px;\r\n  border-radius: 10px;\r\n  -webkit-box-shadow: 5px 5px 5px 0px rgba(190, 169, 169, 0.75);\r\n  -moz-box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);\r\n  box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);\r\n\r\n  font-family: 'Baloo', Courier, monospace;\r\n\r\n  position: relative;\r\n\r\n  transition: all 1s ease;\r\n  border: 1px dashed rgba(0, 0, 0, 0.2);\r\n \r\n}\r\n\r\n\r\n .articulo {\r\n\r\n  \r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  padding-top: 5px;\r\n  \r\n\r\n}\r\n\r\n.articulo h3 {\r\n\r\n  font-family: 'Baloo', Courier, monospace;\r\n  font-size: 20px;\r\n\r\n}\r\n\r\n.articulo p {\r\n\r\n  font-family: 'Baloo', Courier, monospace;\r\n  font-size: 15px;\r\n\r\n}\r\n\r\n\r\n.caracteristicas {\r\n\r\n  margin-top: 5px;\r\n  width: 100%;\r\n  height: auto;\r\n  display: flex;\r\n  justify-content: space-evenly;\r\n  \r\n} \r\n\r\n\r\n.footer {\r\n\r\n  /* position: fixed; */\r\n\r\n  bottom: 0px;\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  color: white;\r\n  display: flex;\r\n  align-items:center;\r\n  justify-content: baseline;\r\n  text-align: center;\r\n  \r\n}\r\n\r\n\r\n.no-scrollcom {\r\n\r\n  background-color: #fafbfd;\r\n  display: inline-block;\r\n  width: 100%;\r\n  margin-top: 1px;\r\n  overflow-y: none;\r\n  overflow-x: auto;\r\n  height: 140px;\r\n  \r\n}\r\n\r\n\r\n.componentes {\r\n\r\n  display: inline-flex;\r\n   flex-direction: column;\r\n  /* justify-content: center;   */\r\n  /* align-items: center;  */\r\n  min-width: 230px;\r\n  height: 130px;\r\n  margin-left: 5px;\r\n  margin-top: 7px;\r\n  margin-bottom: 5px;\r\n  border-radius: 10px;\r\n  background-color: #fff;\r\n  -webkit-box-shadow: 5px 5px 5px 0px rgba(190, 169, 169, 0.75);\r\n  -moz-box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);\r\n  box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);\r\n\r\n  font-family: 'Baloo', Courier, monospace;\r\n  font-size: 13px;\r\n  position: relative;\r\n\r\n  transition: all 1s ease;\r\n \r\n}\r\n\r\n\r\n .componente {\r\n \r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  padding-top: 1px;\r\n\r\n}\r\n\r\n.componente h3 {\r\n\r\n  padding-top: 1px;\r\n\r\n  font-family: 'Baloo', Courier, monospace;\r\n  font-size: 15px;\r\n\r\n}\r\n\r\n.componente p {\r\n\r\n  padding-top: 1px;\r\n\r\n  font-family: 'Baloo', Courier, monospace;\r\n  font-size: 13px;\r\n\r\n}\r\n\r\n\r\n.componente .caracteristicas {\r\n\r\n  margin-top: 1px;\r\n  width: 100%;\r\n  height: auto;\r\n  display: flex;\r\n  justify-content: space-evenly;\r\n  \r\n} \r\n\r\n\r\n.componente .footer {\r\n\r\n  /* position: fixed; */\r\n\r\n  bottom: 0px;\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  color: white;\r\n  display: flex;\r\n  align-items:center;\r\n  justify-content: baseline;\r\n  text-align: center;\r\n  \r\n}\r\n\r\n\r\n\r\n\r\nbutton  {\r\n\r\n  border-radius: 40px;\r\n  padding-left:  8px;\r\n  padding-right: 8px;\r\n}\r\n\r\n\r\n.footer a {\r\n\r\n  /*\r\n  height: 100%;\r\n  display: block;\r\n  text-align: center;\r\n  */\r\n  position: absolute;\r\n  bottom: 0px;\r\n  \r\n  width: 100%;\r\n  cursor: pointer;\r\n  background-color: white;\r\n  color: black;\r\n  border-radius: 0 0 10px 10px;\r\n  transition: all 1s ease;\r\n  font-size: 20px;\r\n\r\n} \r\n\r\n.footer  a:hover {\r\n\r\n  color: white;\r\n  background-color: black;\r\n\r\n}\r\n\r\n\r\n.caracteristicas span {\r\n\r\n  margin-left: 1%;\r\n  width: 25%;\r\n\r\n}\r\n\r\n\r\n.caracteristicas input {\r\n\r\n  width: 65%;\r\n  border: none;\r\n  border-radius: 10px;\r\n  text-align: right;\r\n\r\n}\r\n\r\n\r\n/* Proveedores y clientes */\r\n\r\n.detalleClientes {\r\n\r\n \r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n  gap: 1em;\r\n}\r\n\r\n.clientes {\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;  \r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  flex-basis: 20%;\r\n  height: auto;\r\n  background-color: white;\r\n  /* filter: brightness(1.2); */\r\n  border-radius: 10px;\r\n  border: 1px dashed rgba(0, 0, 0, 0.19);\r\n  -webkit-box-shadow: 5px 5px 5px 0px rgba(190, 169, 169, 0.75);\r\n  -moz-box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);\r\n  box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);\r\n\r\n  transition: all 1s ease;\r\n\r\n\r\n}\r\n\r\n.cliente {\r\n\r\n  margin-top: 5px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  width: 100%;\r\n  gap: 0.5em;\r\n  overflow: hidden;\r\n\r\n}\r\n\r\n.acciones {\r\n\r\n  width: 100%;\r\n  display:inline-flex;\r\n  justify-content: center;\r\n  justify-items: center;\r\n\r\n}\r\n\r\n.clientes .acciones {\r\n\r\n  margin: 1px auto;\r\n\r\n}\r\n\r\n\r\n.agregar {\r\n\r\n  bottom: 0;\r\n  width: 100%;\r\n  text-align: center;\r\n  position: relative;\r\n \r\n  \r\n\r\n}\r\n\r\n\r\n.agregar  a {\r\n\r\n  left: 0px;\r\n  bottom: 0;\r\n  position: absolute;\r\n  width: 100%;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n \r\n  color: black;\r\n  background-color: white;\r\n \r\n \r\n  border-radius: 0 0 10px 10px;\r\n  height: auto;\r\n  cursor: pointer;\r\n  transition: all 1s ease;\r\n\r\n}\r\n\r\n.agregar a:hover {\r\n\r\n  color: white;\r\n  background-color: black;\r\n  \r\n\r\n}\r\n\r\n .cliente h4 {\r\n\r\n  font-size: 11px;\r\n  /*  font-family: 'Baloo', cursive; */\r\n  color: black;\r\n\r\n}\r\n\r\nh4 {\r\n\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-weight: 300;\r\n  font-style: normal;\r\n  font-size: 24px;\r\n  \r\n  color: orange;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  justify-items: center;\r\n  gap: 0.2em;\r\n\r\n}\r\n\r\n.cliente p {\r\n\r\n  font-size: 12px;\r\n  /*  font-family: 'Baloo', cursive; */\r\n  font-weight: 600;\r\n  color: black;\r\n  text-align: center;\r\n}\r\n\r\n.detalleItem {\r\n\r\n  z-index: 5;\r\n  position: fixed;\r\n  top: 0px;\r\n  right:0px;\r\n  height: 100%;\r\n  width: 100%;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: rgba(51, 58, 70, 0.8);\r\n\r\n}\r\n\r\n.nuevo {\r\n\r\n  z-index: 2;\r\n  position: fixed;\r\n  top: 0px;\r\n  right:0px;\r\n  height: 100%;\r\n  width: 100%;\r\n  background-color: white;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: rgba(0,0,0,0.8);\r\n\r\n}\r\n\r\n.detalleItem .contenedor{\r\n\r\n  position: absolute;\r\n  top:80px;\r\n  bottom:120px;\r\n  right: 0px;\r\n  width: 60%;\r\n  height: 80%;\r\n  overflow-y: hidden;\r\n}\r\n\r\n/* .proveedores {\r\n\r\n  z-index: 5;\r\n  position: absolute;\r\n  margin-top: 25px;\r\n  right: 0px;\r\n  width: 100%;\r\n  max-height: 300px;\r\n  overflow-y: auto;\r\n  cursor: pointer;\r\n} */\r\n\r\n.mensaje {\r\n\r\n  z-index: 5;\r\n  position: absolute;\r\n  right: 0px;\r\n  width: 90%;\r\n  bottom: 0px;\r\n  overflow-y: auto;\r\n  cursor: pointer;\r\n}\r\n\r\n.input-label {\r\n\r\n  background-color: transparent;\r\n  overflow: hidden;\r\n  border: none;\r\n  width: 500px;\r\n  color: black;\r\n}\r\n\r\n\r\nh1 span {\r\n\r\n  font-size: 15px;\r\n  color: #333;\r\n\r\n}\r\n\r\nh1 span::before {\r\n\r\n  content: \"(( \";\r\n  color: orange;\r\n\r\n}\r\n\r\nh1 span::after {\r\n\r\n  content: \" ))\";\r\n  color: orange;\r\n\r\n}\r\n\r\n\r\n.color-azul {\r\n\r\n  color: blue;\r\n  font-size: 13px;\r\n\r\n}\r\n\r\n.color-rojo {\r\n\r\n  color: red;\r\n  font-size: 13px;\r\n}\r\n\r\n.alto-tabla {\r\n\r\n  min-height: 100px;\r\n  max-height: 350px;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n\r\n}\r\n\r\n\r\n.detalleItem .contenedor .items {\r\n\r\n  background-color: white;\r\n  width: 100%;\r\n  height:auto;\r\n  overflow: auto;\r\n\r\n}\r\n\r\n.nuevo .contenedor-modal{\r\n\r\n\r\n  position: absolute;\r\n  background-color:white;\r\n  top:0px;\r\n  right: 0px;\r\n  width: 80%;\r\n  height: 100%;\r\n\r\n}\r\n\r\n.items {\r\n  padding-top:10px;\r\n  padding-bottom: 40px;\r\n  background-color: white;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: auto;\r\n\r\n}\r\n\r\n.division {\r\n\r\n  position: relative;\r\n  margin-bottom: 2px;\r\n  width: 100%;\r\n  height: 35px;\r\n  background-color: whitesmoke;\r\n}\r\n\r\n.division .boton {\r\n\r\n  position: absolute;\r\n  left: 0px;\r\n  height: 100%;\r\n\r\n}\r\n\r\n.efecto-filtro {\r\n\r\n  filter: blur(0px);\r\n\r\n\r\n}\r\n\r\n.movimiento {\r\n\r\n  transition: all 0.5s ease;\r\n\r\n}\r\n\r\n.filtro {\r\n\r\n  filter: blur(8px);\r\n\r\n}\r\n\r\n.clientes:hover {\r\n\r\n  transform: scale(1.05);\r\n\r\n}\r\n\r\n.mostrar-cursor {\r\n\r\n  cursor: pointer;\r\n\r\n}\r\n\r\n.modal-entidad {\r\n\r\n  position: fixed;\r\n  z-index: 3;\r\n  top: 35px;\r\n  right:0px;\r\n  height: 380px;\r\n  width: 500px;\r\n  background-color: white;\r\n  border-bottom: dashed 1px ;\r\n}\r\n\r\n.lista-alto {\r\n\r\n  height: 200px;\r\n  width: 100%;\r\n  overflow-y: auto;\r\n\r\n}\r\n\r\n.modal-entidad-items {\r\n\r\n  position: absolute;\r\n  margin-top: 2px;\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n\r\n}\r\n\r\n.row input {\r\n\r\n  border-radius: 10px;\r\n\r\n}\r\n\r\n.rows {\r\n\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-bottom: 7px;\r\n  \r\n\r\n}\r\n\r\n\r\n.rows .buscar {\r\n\r\n \r\n  width: 0;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  transition: all 1s ease;\r\n\r\n}\r\n\r\nhr {\r\n\r\n  margin-top: 1px;\r\n  margin-left: 5px;\r\n  left: 0px;\r\n  background-color: orange;\r\n  height: 2px;\r\n  width: 45%;\r\n\r\n\r\n}\r\n\r\n.rows .buscar-mostrar {\r\n\r\n  border-radius: 40px;\r\n  width: 45%;\r\n  height: 40px;\r\n  margin-right: 5px;\r\n  margin-left: 10px;\r\n  opacity: 1;\r\n  background-color: lightgray;\r\n  transition: all 0.5s ease;\r\n}\r\n\r\n.rows .buscar-mostrar:focus {\r\n\r\n  background-color: transparent;\r\n\r\n}\r\n\r\n.rows span {\r\n\r\n  transition: all 0.5s ease;\r\n\r\n}\r\n\r\n/* Clientes */\r\n.no-scrollusr {\r\n\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 100%;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  height: 65vh;\r\n\r\n\r\n}\r\n\r\n.no-scrollusr a {\r\n\r\n   margin: 10px 10px;\r\n   font-size: 15px;\r\n   color: orange;\r\n\r\n}\r\n\r\n.no-scrollusr a:hover {\r\n\r\n  cursor: pointer;\r\n  color: blue;\r\n\r\n}\r\n\r\n#modal-basic-title {\r\n\r\n  margin-left: 10px;\r\n  font-family: 'Ballo', Verdana, Geneva, Tahoma, sans-serif;\r\n  font-size: 30px;\r\n  font-weight: 600;\r\n  color: orange;\r\n\r\n}\r\n\r\n.alto-tabla {\r\n\r\n  display: inline-block;\r\n  width: 100%;\r\n  margin-top: 1px;\r\n  margin-left: 5px;\r\n  margin-right: 5px;\r\n  \r\n  max-height: 250px;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n\r\n}\r\n\r\n.centrar {\r\n\r\n  text-align: center;\r\n  margin-top: 30px;\r\n\r\n}\r\n\r\n\r\n/**/\r\n\r\n.empresas {\r\n\r\n  display: inline-block;\r\n  width: 100%;\r\n  height: auto;\r\n  right: auto;\r\n  left: auto;\r\n  \r\n  overflow: hidden;\r\n  }\r\n  \r\n  .empresas .items {\r\n  \r\n    display: inline-block;\r\n    width: 300px;\r\n    margin-right: 15px;\r\n    max-height: 300px;\r\n    margin-bottom: 15px;\r\n    overflow: hidden;\r\n    color: #333;\r\n    box-shadow: 5px 5px 5px 0px rgba(51, 51, 51, 0.20);\r\n    -webkit-box-shadow: 5px 5px 5px 0px rgba(51, 51, 51, 0.20);\r\n    -moz-box-shadow: 5px 5px 5px 0px rgba(51, 51, 51, 0.20);\r\n    border-radius: 5px;\r\n\r\n  }\r\n  \r\n  .empresas .items img {\r\n  \r\n    width: 150px;\r\n    height: 150px;\r\n  \r\n  }\r\n  \r\n  .empresas .items .empresa {\r\n  \r\n    width: 100%;\r\n    height: 100%;\r\n   display: flex;\r\n   flex-direction: column;\r\n\r\n  }\r\n\r\n  .empresas .items .empresa p {\r\n\r\n    margin: 1px;\r\n    font-size: 15px;\r\n\r\n  }\r\n\r\n  .empresas .acciones {\r\n\r\n    width: 100%;\r\n    height: auto;\r\n    display:flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: center;\r\n    \r\n  }\r\n  \r\n/**/\r\n\r\n.contenedor-listado {\r\n\r\n  margin-left: 0;\r\n  margin-top: 20px;\r\n  padding: 0px;\r\n  width: 100%;\r\n  height: 300px;\r\n  display: flex;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  \r\n}\r\n\r\n\r\n.listado {\r\n\r\n  width: 100%;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n}\r\n\r\n\r\n.listado-art {\r\n\r\n  z-index: 5;\r\n  position: absolute;\r\n  width: 97%;\r\n  max-height: 200px;\r\n  cursor: pointer;\r\n\r\n\r\n}\r\n\r\n.listado-art ul {\r\n\r\n  height: 200px;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.tablas-block {\r\n\r\n  display: inline-block;\r\n  width: 90%;\r\n  height: auto;\r\n  text-align: left;\r\n  margin-left: auto;\r\n  margin-top: 7px;\r\n  margin-bottom: 8px;\r\n  margin-right: auto;\r\n  background-color: white;\r\n\r\n  -webkit-box-shadow: 5px 5px 5px 0px rgba(190, 169, 169, 0.75);\r\n  -moz-box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);\r\n  box-shadow: 5px 5px 5px 0px  rgba(190, 169, 169, 0.75);\r\n\r\n\r\n}\r\n\r\n.tablas-block .agregar {\r\n\r\n margin: 5px auto;\r\n\r\n}\r\n\r\n.items-tabla {\r\n\r\n  margin: 3px;\r\n  width: 100%;\r\n  background-color: white;\r\n\r\n  overflow: hidden;\r\n\r\n}\r\n\r\n.identificador {\r\n\r\n  width: 49%;\r\n  font-family: 'Baloo', cursive;\r\n  padding-right: 5px;\r\n  text-align: right;\r\n \r\n}\r\n\r\n.detalle {\r\n\r\n  width: 49%;\r\n  color: #333;\r\n  text-align: left;\r\n  padding-right: 5px;\r\n  font-family: 'Alatsi', cursive;\r\n\r\n\r\n  }\r\n\r\n\r\n@media screen and (max-width:820px) {\r\n\r\n  .contenedor-basicos {\r\n\r\n    width: 100%;\r\n\r\n  }\r\n\r\n .clientes {\r\n\r\n   flex-basis: 30%;\r\n\r\n  } \r\n\r\n  .empresas .items {\r\n  \r\n    display: inline-block;\r\n    padding:  5px;\r\n    width: 100%;\r\n    height: auto;\r\n  }\r\n\r\n}\r\n\r\n/* Formateamos el label que servirá de contenedor */\r\n.switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 30px;\r\n  height: 17px;\r\n}\r\n\r\n/* Ocultamos el checkbox html */\r\n.switch input {\r\n  display:none;\r\n}\r\n\r\n/* Formateamos la caja del interruptor sobre la cual se deslizará la perilla de control o slider */\r\n.slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: #ccc;\r\n  -webkit-transition: .4s;\r\n  transition: .4s;\r\n}\r\n\r\n/* Pintamos la perilla de control o slider usando el selector before */\r\n.slider:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 13px;\r\n  width: 13px;\r\n  left: 2px;\r\n  bottom: 2px;\r\n  background-color: white;\r\n  -webkit-transition: .4s;\r\n  transition: .4s;\r\n}\r\n\r\n/* Cambiamos el color de fondo cuando el checkbox esta activado */\r\ninput:checked + .slider {\r\n  background-color: #E27AD8;\r\n}\r\n\r\n/* Deslizamos el slider a la derecha cuando el checkbox esta activado */\r\ninput:checked + .slider:before {\r\n  -webkit-transform: translateX(13px);\r\n  -ms-transform: translateX(13px);\r\n  transform: translateX(13px);\r\n}\r\n\r\n/* Aplicamos efecto de bordes redondeados en slider y en el fondo del slider */\r\n.slider.round {\r\n  border-radius: 17px;\r\n}\r\n\r\n.slider.round:before {\r\n  border-radius: 50%;\r\n}\r\n\r\n.centrar-label {\r\n\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.w-15 {\r\n\r\n  width: 15%;\r\n\r\n}\r\n\r\n.proveedores {\r\n\r\n  z-index: 5;\r\n  position: absolute;\r\n  width: 95%;\r\n  cursor: pointer;\r\n  max-height: 300px;\r\n  overflow: auto;\r\n\r\n}\r\n\r\n.proveedores .ulx {\r\n\r\n  position: relative;\r\n  height: 100%;\r\n\r\n}\r\n\r\n.paginas {\r\n\r\n  margin-left: 5px;\r\n  width: 100%;\r\n  height: auto;\r\n  overflow-x:auto;\r\n \r\n\r\n}\r\n\r\n.paginas::-webkit-scrollbar {\r\n\r\n  width: 0.5rem;\r\n  height: 0.5rem;\r\n\r\n}\r\n\r\n.paginas::-webkit-scrollbar-thumb {\r\n\r\n border-radius: .5rem;\r\n background-color: #0004;\r\n visibility: hidden;\r\n\r\n}\r\n\r\n.paginas:hover::-webkit-scrollbar-thumb {\r\n\r\n  visibility: visible;\r\n\r\n}\r\n\r\n\r\n.proveedores .ulx li {\r\n\r\n\r\n  background-color: #333;\r\n  color: white;\r\n  border-bottom-color: white;\r\n  font-family: 'Alatsi', Courier, monospace;\r\n\r\n}\r\n\r\n/* LOCALIDADES */\r\n.presentacion {\r\n\r\n  margin: 0px;\r\n  width: 100%;\r\n\r\n  max-height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n\r\n\r\n\r\n}\r\n\r\n.presentacion .detalles {\r\n\r\nmargin: 0px;\r\nwidth: 100%;\r\nheight: 100%;\r\npadding-bottom: 1px;\r\ndisplay: flex;\r\nflex-direction: row;\r\nalign-items: center;\r\njustify-content: center;\r\n\r\n\r\n\r\n}\r\n\r\n.presentacion .detalles .items {\r\n\r\nmargin: 5px;\r\nwidth: 30%;\r\nheight: 600px ;\r\npadding: 0px;\r\ndisplay: flex;\r\nflex-direction: column;\r\njustify-content: center;\r\nalign-items: center;\r\npadding-top: 3px;\r\noverflow: hidden;\r\ncursor: pointer;\r\n\r\nborder-bottom: 0.3px solid lightgray;\r\n\r\n\r\n\r\n}\r\n\r\n.presentacion .detalles .items:hover {\r\n\r\nbackground-color:  white;\r\n-webkit-box-shadow: 0px 0px 10px 1px rgba(190, 169, 169, 0.75);\r\n-moz-box-shadow: 0px 0px 10px 1px  rgba(190, 169, 169, 0.75);\r\nbox-shadow: 0px 0px 10px 1px  rgba(190, 169, 169, 0.75);\r\n\r\n}\r\n\r\n\r\n\r\n.presentacion .detalles .items .fondo-logo {\r\n\r\nmargin-top: 50px;\r\nmargin: 1px;\r\nwidth: 100%;\r\nheight:30%;\r\n\r\ndisplay: flex;\r\nflex-direction: column;\r\nalign-items: center;\r\noverflow: hidden;\r\n\r\n}\r\n\r\n.presentacion .detalles .items .logo {\r\n\r\nmargin-top: 50px;\r\nmargin: 1px;\r\nwidth: 40%;\r\n\r\nheight:auto;\r\n\r\n}\r\n\r\n.presentacion .detalles .items  .logo img {\r\n\r\n\r\nbackground: transparent;\r\n\r\nwidth: 100%;\r\nheight: auto;\r\nborder-radius: 50%;\r\n\r\n\r\n}\r\n\r\n.presentacion .detalles .items .subtitulo {\r\n\r\npadding-top: 1px;\r\nmargin: 1px;\r\nwidth: 100%;\r\n\r\nheight:auto;\r\nbackground-size: cover;\r\ntext-align: center;\r\n\r\n}\r\n\r\n.presentacion .detalles .items .subtitulo h1 {\r\n\r\nwidth: 100%;\r\nmargin-top: 2px;\r\nfont-size: 150%;\r\n\r\ncolor: #e26a2c;\r\ntext-align: center;\r\n\r\n}\r\n\r\n.presentacion .detalles .items  .resumen {\r\n\r\npadding-top: 1px;\r\nmargin: 1px;\r\nwidth: 100%;\r\nheight: 90%;\r\noverflow: hidden;\r\nbackground-size: cover;\r\ntext-align: center;\r\npadding-bottom: 0px;\r\nmargin-bottom: 0px;\r\n\r\n\r\n\r\n}\r\n\r\n.presentacion .detalles .items .resumen h2 {\r\n\r\nwidth: 100%;\r\npadding: 10px;\r\ncolor: #3d3d3e;\r\ntext-align: justify;\r\nfont-size: 18px;\r\nfont-size: 110%;\r\n\r\n\r\n}\r\n\r\n.naranja1 {\r\n\r\nbackground-color: #ffd792;\r\nbackground-color: white;\r\n\r\n}\r\n.naranja2 {\r\n\r\nbackground-color: #ffae6a;\r\nbackground-color: whitesmoke;\r\n\r\n}\r\n\r\n/*@GOOGLE*/\r\n.material-symbols-outlined {\r\n  cursor: pointer;\r\n  font-variation-settings:\r\n  'FILL' 0,\r\n  'wght' 400,\r\n  'GRAD' 0,\r\n  'opsz' 24\r\n}\r\n\r\n.btn-google {\r\n\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.md-24 {\r\n\r\n  font-size: 24px;\r\n\r\n}\r\n\r\n.md-25 {\r\n\r\n  font-size: 24px;\r\n\r\n}\r\n\r\n.md-36 {\r\n\r\n  font-size: 36px;\r\n\r\n}\r\n\r\n.md-48 {\r\n\r\n  font-size: 48px;\r\n\r\n}\r\n\r\n/*@GOOGLE*/\r\n\r\n@media screen and (max-width:920px) { \r\n\r\n /*LOCALIDADES*/\r\n\r\n .presentacion .detalles {\r\n\r\n  width: 100%;\r\n  height:auto;\r\n  flex-direction: column;\r\n\r\n}\r\n\r\n.presentacion .detalles .items {\r\n\r\n  width: 100%;\r\n  height: 100%;\r\n  /* -webkit-box-shadow: 0px 2px 2px 0px rgba(190, 169, 169, 0.75);\r\n  -moz-box-shadow: 0px 2px 2px 0px  rgba(190, 169, 169, 0.75);\r\n  box-shadow: 0px 2px 2px 0px  rgba(190, 169, 169, 0.75); */\r\n\r\n\r\n}\r\n\r\n.presentacion .detalles .items .logo {\r\n\r\n\r\n  width: 25%;\r\n  height: auto;\r\n\r\n}\r\n\r\n\r\n}\r\n\r\n\r\n@media screen and (max-width:720px) {\r\n\r\n  .contenedor-basicos {\r\n\r\n    width: 100%;\r\n\r\n  }\r\n\r\n  .nuevo .contenedor {\r\n\r\n    width: 100%;\r\n\r\n  }\r\n\r\n  /* .clientes {\r\n\r\n    width: 100%;\r\n    min-width: 120px;\r\n\r\n  } */\r\n\r\n \r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
